export { getPluginVersion, getCustomerPortalFrontendBuildKey } from './build-info';
